var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative h-6 rounded-full",class:{
    'pointer-events-none': _vm.disable,
    'opacity-50': _vm.disable,
    'bg-main-2': !_vm.value,
    'bg-primary': _vm.value,
  },staticStyle:{"width":"3.5rem","transform":"scale(var(--scale, 1))"}},[_c('input',{staticClass:"opacity-0 border-none outline-none absolute z-10 w-full h-full cursor-pointer",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', !_vm.value)}}}),_c('div',{staticClass:"rounded-full absolute transform transition-transform duration-300 ease-out shadow-lg bg-dropdown flex flex-col justify-center items-center",class:{
      'translate-x-0': !_vm.value,
      'translate-x-full': _vm.value,
    },staticStyle:{"top":"-1px","height":"1.7rem","width":"1.7rem"},style:({
      left: _vm.value ? '2px' : '0px',
      'box-shadow': _vm.value
        ? '2px 0px 4px rgba(0, 0, 0, 0.15)'
        : '-2px 0px 4px rgba(0, 0, 0, 0.15)',
    })},[(_vm.is_loading)?_c('spinner',{staticClass:"w-full h-full text-primary"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }